/** @file PadletJamboardDrawGroup schema */
import { defaultColorNames, T, TLBaseShape, TLDefaultSizeStyle, TLDrawShapeSegment } from 'tldraw'

const DrawShapeSegment = T.object<PadletJamboardDrawGroupStroke>({
  type: T.literalEnum('free', 'straight'),
  points: T.arrayOf(T.object({ x: T.number, y: T.number, z: T.optional(T.number), velocity: T.optional(T.number) })),
  strokeType: T.literalEnum('draw', 'highlight', 'eraser'),
  strokeSize: T.number,
  strokeColor: T.optional(T.literalEnum(...defaultColorNames)),
  strokeOpacity: T.optional(T.number),
})

const padletJamboardDrawGroupShapeProps = {
  w: T.number,
  h: T.number,
  strokes: T.arrayOf(DrawShapeSegment),
  size: T.literalEnum('s', 'm', 'l', 'xl'),
  scale: T.number,
  hasDoneFirstLoad: T.optional(T.boolean),
  image: T.optional(T.string),
}

interface Point {
  x: number
  y: number
  z?: number
  velocity?: number
}

type PadletJamboardDrawGroupStroke = TLDrawShapeSegment & {
  points: Point[]
  strokeType: 'draw' | 'highlight' | 'eraser'
  strokeSize: number
  strokeColor?: typeof defaultColorNames[number]
  strokeOpacity?: number
}

interface PadletJamboardDrawGroupShapeProps {
  w: number
  h: number
  strokes: PadletJamboardDrawGroupStroke[]
  size: TLDefaultSizeStyle
  scale: number
  hasDoneFirstLoad?: boolean
  image?: string
}

type PadletJamboardDrawGroupShape = TLBaseShape<'padlet-jamboard-draw-group', PadletJamboardDrawGroupShapeProps>

export { PadletJamboardDrawGroupShape, PadletJamboardDrawGroupShapeProps, padletJamboardDrawGroupShapeProps }
